import React, {Component} from 'react'
import Title from '../Login/Components/title/title.jsx'
import AddButton from '../../commons/AddButton.jsx';
import '../Login/styles.css'
import { Link, Redirect} from 'react-router-dom'
import Auth from './Components/Auth.jsx';
import FacebookLogin from './Components/FacebookLogin.jsx';
import firebaseManager from '../../model/Firebase/FirebaseManager'
import BarraSupDent from '../../commons/NavUp';


class Login extends Component {
  
     // fake authentication Promise
     authenticate(){
      return new Promise(resolve => setTimeout(resolve, 1000)) // 2 seconds
    }
  
    componentDidMount(){
      this.authenticate().then(() => {
        const ele = document.getElementById('ipl-progress-indicator')
        if(ele){
          // fade out
          ele.classList.add('available')
          setTimeout(() => {
            // remove from DOM
            ele.outerHTML = ''
          }, 1000)
        }
      })
    }
    constructor()
    {
        super()
        this.state={
            redirectToHome: false
        }
    }
    

  signInWithGoogle = () =>{
    firebaseManager.loginUserWithGmail(this.loginCallbackSuccess,this.loginCallbackFail);  
  }
 
  loginCallbackSuccess = () => {
    this.setState({
        redirectToHome: true
    })
  }
  loginCallbackFail(errMessage) {
   alert(errMessage)
}

    render() {
      
      return (
        <div>
           
           { this.state.redirectToHome ? (<Redirect push to="/home"/>) : null }
                <div className="text-center">
                  <BarraSupDent />
                  <div id="alertLogin" className="alert alert-danger d-none" role="alert"></div>
                  <Title text1 ="Right now, DENT is only avaible in Los Angeles"/>
                  <Auth />
                  <div className="text-center mt-2">
                  <FacebookLogin />
                  </div>
                  <div className="text-center mt-2">
                  <button className="btn btnGoogle mt-1 mx-auto" onClick={this.signInWithGoogle}>Sign in with Google</button>    
                  </div>
                  <div className="mt-5 mb-5">
                  <hr/><p className="d-inline text-muted">or</p> <hr/> 
                  </div>
                  <Link to = "/createUser">
                    <AddButton text="Sign Up" />
                  </Link>
                </div>    
            
        </div>
      );
    }
  }
  
export default Login;

